import React, { useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import { iconNumbers, iconPOI } from '../MapComponents/mapIcons';
import { Place } from '../../models/Place';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { LeafletEvent } from 'leaflet';

type PlaceMarkerProps = {
	places: Place[];
};

const StoryPlaceMarkers: React.FC<PlaceMarkerProps> = ({ places }) => {
	const [showToasts, setShowToasts] = useState(false);
	const [clusterToasts, setClusterToasts] = useState(false);
	const handleClusterClick = (e: LeafletEvent) => {
		console.log('Click : ', e);
		console.log('Markers : ', e.layer.getAllChildMarkers());
	};

	return (
		<>
			{/*<MarkerClusterGroup onClick={handleClusterClick} chunkedLoading>*/}
			{places.map((position, idx) => {
				return (
					<Marker
						key={`marker-${position.id}`}
						position={position.toLatLng()}
						icon={iconNumbers[idx]}>
						{/*<Popup>*/}
						{/*	<span>*/}
						{/*		<strong>{position.title}</strong>*/}
						{/*	</span>*/}
						{/*	<br />*/}
						{/*	<span>{position.short_description}</span>*/}
						{/*</Popup>*/}
					</Marker>
				);
			})}
			{/*</MarkerClusterGroup>*/}
		</>
	);
};

export default StoryPlaceMarkers;
